document.addEventListener("DOMContentLoaded", function () {
    loadWishlists();
});

// Função para criar uma nova lista
function createWishlist() {
    let listName = document.getElementById("new-list-name").value.trim();
    if (!listName) {
        alert("Digite um nome válido para a lista.");
        return;
    }

    let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};
    if (wishlists[listName]) {
        alert("Essa lista já existe!");
        return;
    }

    wishlists[listName] = []; // Criar uma nova lista vazia
    localStorage.setItem("wishlists", JSON.stringify(wishlists));
    loadWishlists();
}

// Função para adicionar um produto à wishlist
function addToWishlist(productId, productTitle, productImage, productUrl, listName) {
    let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};

    if (!wishlists[listName]) {
        alert("Lista não encontrada!");
        return;
    }

    // Verifica se o produto já está na lista
    if (wishlists[listName].some(item => item.id === productId)) {
        alert("Produto já está na lista!");
        return;
    }

    // Adiciona o produto com a URL
    wishlists[listName].push({ 
        id: productId, 
        title: productTitle, 
        image: productImage, 
        url: productUrl  // Ensure URL is saved
    });

    localStorage.setItem("wishlists", JSON.stringify(wishlists));
    loadWishlists();
}


// Função para remover um produto da wishlist
function removeFromWishlist(productId, listName) {
    let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};

    if (!wishlists[listName]) return;

    wishlists[listName] = wishlists[listName].filter(item => item.id !== productId);
    localStorage.setItem("wishlists", JSON.stringify(wishlists));
    loadWishlists();
}

// Função para carregar as wishlists na página e organizar os produtos por lista
function loadWishlists() {
    let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};
    let listsContainer = document.getElementById("wishlist-lists");

    listsContainer.innerHTML = ""; // Limpa o conteúdo antes de carregar novamente

    if (Object.keys(wishlists).length === 0) {
        listsContainer.innerHTML = '<p class="center">Você ainda não criou nenhuma lista de desejos.</p>';
        return;
    }

    // Percorre todas as listas criadas
    Object.keys(wishlists).forEach(listName => {
        let listElement = document.createElement("div");
        listElement.classList.add("wishlist-group");

        // Criando o título da lista
        listElement.innerHTML = `
            <h3 class="wishlist-title-list">${listName} <button class="wishlist-button-remove" onclick="deleteWishlist('${listName}')"><span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg>
</span></button></h3>
            <div class="wishlist-products" id="wishlist-${listName}"></div>
        `;

        listsContainer.appendChild(listElement);

        let productsContainer = document.getElementById(`wishlist-${listName}`);

        if (wishlists[listName].length === 0) {
            productsContainer.innerHTML = "<p>Esta lista está vazia.</p>";
        } else {
            // Exibe os produtos da lista
            wishlists[listName].forEach(product => {
                let productElement = document.createElement("div");
                productElement.classList.add("wishlist-item");
                productElement.innerHTML = `
                    <img src="${product.image}" width="50">
                    <a href="${product.url}">${product.title}</a>
                    <button onclick="removeFromWishlist('${product.id}', '${listName}')">
                      <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg></span>
                    </button>
                    
                `;
                productsContainer.appendChild(productElement);
            });
        }
    });
}

// Função para deletar uma lista
function deleteWishlist(listName) {
    // Exibe uma caixa de diálogo de confirmação
    const isConfirmed = confirm("Tem a certeza que deseja apagar esta Lista de Compras?");
    
    // Se o usuário confirmar, prossegue com a exclusão
    if (isConfirmed) {
        let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};
        delete wishlists[listName];
        localStorage.setItem("wishlists", JSON.stringify(wishlists));
        loadWishlists(); // Recarrega as listas após a exclusão
    }
}

// Função para exibir a seleção de wishlist
    window.showWishlistOptions = function (productId, productTitle, productImage, productUrl) {
        let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};
        let listNames = Object.keys(wishlists);

        if (listNames.length === 0) {
            alert("Crie uma lista primeiro!");
            return;
        }

        // Remover qualquer menu antigo antes de adicionar um novo
        let existingMenu = document.getElementById("wishlist-menu");
        if (existingMenu) {
            existingMenu.remove();
        }

        // Criar menu de seleção de lista
        let div = document.createElement("div");
        div.id = "wishlist-menu";
        div.classList.add("wishlist-menu"); // Adiciona a classe
        document.body.appendChild(div);

        div.innerHTML = `<p>Escolha uma Lista de Compras:</p>`;

        listNames.forEach(name => {
            let button = document.createElement("button");
            button.textContent = name;
            button.classList.add("button-list-names"); // Adiciona a classe

            button.onclick = function () {
                addToWishlist(productId, productTitle, productImage, productUrl, name); // Agora inclui o URL
                div.remove();
            };

            div.appendChild(button);
        });

        // Botão de fechar
        let closeButton = document.createElement("button");
        closeButton.textContent = "Cancelar";
        closeButton.classList.add("button-list-cancel"); // Adiciona a classe

        closeButton.onclick = function () {
            div.remove();
        };

        div.appendChild(closeButton);

        document.body.appendChild(div);
    };

    // Função para adicionar um produto à lista desejada
    window.addToWishlist = function (productId, productTitle, productImage, productUrl, listName) {
        let wishlists = JSON.parse(localStorage.getItem("wishlists")) || {};

        if (!wishlists[listName]) {
            alert("Lista não encontrada!");
            return;
        }

        // Verifica se o produto já está na lista
        if (wishlists[listName].some(item => item.id === productId)) {
            alert("Produto já está na lista!");
            return;
        }

        // Adiciona o produto à lista, agora incluindo o URL
        wishlists[listName].push({
            id: productId,
            title: productTitle,
            image: productImage,
            url: productUrl  // Agora o URL é salvo
        });

        localStorage.setItem("wishlists", JSON.stringify(wishlists));

        alert(`Produto "${productTitle}" adicionado à lista "${listName}"!`);
    };